export const SITE_URL = 'https://codingwithghonaim.com';
export const SITE_NAME = 'البرمجة مع غنيم';
export const SITE_NAME_EN = 'Coding With Ghonaim';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const OG_LOCALE = 'ar_EG';
export const BRAND_SUFFIX = ` | ${SITE_NAME}`;

export const ORGANIZATION = {
    name: SITE_NAME,
    alternateName: SITE_NAME_EN,
    url: SITE_URL,
    email: 'info@codingwithghonaim.com',
    telephone: '+201234511022',
};
